import { IFormBuilderItemBase, IFormBuilderItemDataBase, TFormBuilderItem } from "./formBuilderItem";

type TFormBuilderTextType = "text";
export type TFormBuilderTextRole = "heading" | "paragraph";

export interface IFormBuilderTextSettings {
  content: string;
}

export interface IFormBuilderTextData extends IFormBuilderItemDataBase {
  type: TFormBuilderTextType;
  role: TFormBuilderTextRole;
  settings: IFormBuilderTextSettings;
}

export interface IFormBuilderText extends IFormBuilderItemBase {
  data: IFormBuilderTextData;
}

export type TFormBuilderTextSettings = IFormBuilderText["data"]["settings"];

export function isFormBuilderTextItem(item: TFormBuilderItem): item is IFormBuilderText {
  return item.data.type === "text";
}

export function isFormBuilderTextType(value: string): value is TFormBuilderTextType {
  return value === "text";
}

export function isFormBuilderTextRole(value: string): value is TFormBuilderTextRole {
  return value === "heading" || value === "paragraph";
}

export function formBuilderGenerateDefaultHeadingText(): IFormBuilderText {
  return {
    id: null,
    key: crypto.randomUUID(),
    type: "item",
    data: {
      formRowId: null,
      type: "text",
      role: "heading",
      settings: {
        content: "Heading", // TODO: Translation
      },
    },
  };
}

export function formBuilderGenerateDefaultParagraphText(): IFormBuilderText {
  return {
    id: null,
    key: crypto.randomUUID(),
    type: "item",
    data: {
      formRowId: null,
      type: "text",
      role: "paragraph",
      settings: {
        content: "Paragraph", // TODO: Translation
      },
    },
  };
}